var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"product__specification"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('SKU')))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.productSku))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }